import { RVField } from "../contexts/types";

/**
 * Formats a field label by applying various transformations:
 * - Special case handling for 'has_recallable'
 * - Replace underscores with spaces
 * - Handle ID/IDs capitalization
 * - Handle YTD abbreviation
 * - Capitalize only the first letter of the entire label
 */
export const formatFieldLabel = (label: string): string => {
  if (label === "has_recallable") {
    return "Has recallable (Y/N)";
  } else if (label === "investor_facing_entity_name") {
    return "Investor-facing entity name";
  }

  const formattedLabel = label
    .replace(/_/g, " ")
    .replace(/ ids$/, " IDs")
    .replace(/ id$/, " ID")
    .replace(/\bytd\b/gi, "YTD");

  return formattedLabel.charAt(0).toUpperCase() + formattedLabel.slice(1);
};

/**
 * Processes an array of fields by formatting their labels.
 * Returns a new array with updated labels, leaving fields without labels unchanged.
 */
export const processFields = (fields: RVField[]): RVField[] => {
  return fields.map((field) => {
    if (!field.label) return field;

    return {
      ...field,
      label: formatFieldLabel(field.label),
    };
  });
};
